<template>
    <div class="pages">
        <div class="page" v-if="!showForm">
            <div class="header">
                <h1>{{ $t('vatNumbers.title') }}</h1>
                <div class="action fas fa-plus" @click="create"></div>
            </div>

            <table class="overview">
                <thead>
                <tr>
                    <th>{{ $t('vatNumbers.overview.debtor') }}</th>
                    <th>{{ $t('vatNumbers.overview.number') }}</th>
                    <th width="40"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id" @click="edit(item)">
                    <td>{{ item.debtor.name }}</td>
                    <td>{{ item.number }}</td>
                    <td><i class="fas fa-trash" @click.stop="remove(item.id)"></i></td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="page" v-if="showForm">
            <div class="header">
                <h1 v-if="!form.id">{{ $t('vatNumbers.form.title.add') }}</h1>
                <h1 v-else>{{ $t('vatNumbers.form.title.edit') }}</h1>
            </div>
            <table class="form">
                <tr>
                    <td width="50%"><label for="debtor">{{ $t('vatNumbers.form.debtor') }}</label></td>
                    <td>
                        <select id="debtor" v-model="form.debtor">
                            <option disabled :value="null">{{ $t('vatNumbers.form.chooseDebtor') }}</option>
                            <option v-for="debtor in debtors" :value="debtor">{{ debtor.name }}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td width="50%"><label for="number">{{ $t('vatNumbers.form.vatNumber') }}</label></td>
                    <td><input type="text" id="number" v-model="form.number" @keyup.enter="create()"></td>
                </tr>
            </table>

            <button type="submit" @click="save">{{ $t('action.save') }}</button>
            <button type="submit" class="cancel" @click="close">{{ $t('action.cancel') }}</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'VatNumbers',
        title: 'menu.vatNumbers',
        icon: 'fas fa-address-book',
        data() {
            return {
                items: [],
                showForm: false,
                debtors: [],
                form: {
                    number: null,
                    debtor: null
                }
            };
        },
        mounted() {
            this.load();
        },
        methods: {
            async load() {
                this.items = await this.request('GET', 'vatNumbers');
                this.debtors = await this.request('GET', 'debtors');

                this.showForm = false;
            },
            async create() {
                // Reset form data
                this.form.number = null;
                this.form.debtor = null;

                this.showForm = true;
            },
            async save() {
                if (!this.form.id) {
                    await this.request('POST', 'vatNumbers', this.form);
                } else {
                    await this.request('PUT', 'vatNumbers/' + this.form.id, this.form);
                }

                // Load new data
                this.load();
            },
            edit(item) {
                this.form = Object.assign({}, item);

                this.showForm = true;
            },
            close() {
                this.load();
            },
            async remove(id) {
                if (confirm(this.$t('action.removeConfirmationMessage'))) {
                    await this.request('DELETE', 'vatNumbers/' + id);
                    this.load();
                }
            }
        }
    }
</script>